import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";

const ta = "w-full rounded-lg border border-zinc-200 px-3 py-2 text-sm outline-none focus:border-[#C5A46D]";

export function MomDialog({ meeting, onOpenChange, onSaved }) {
  const [f, setF] = useState({ discussion: "", decisions: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (meeting) setF({ discussion: meeting.mom?.discussion || "", decisions: meeting.mom?.decisions || "" }); }, [meeting]);
  const save = async () => {
    setBusy(true);
    try { await api.post(`/meetings/${meeting.id}/mom`, f); toast.success("MOM published — attendees notified and emailed the minutes"); onSaved(); onOpenChange(false); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <Dialog open={!!meeting} onOpenChange={onOpenChange}>
      <DialogContent data-testid="mom-form" className="sm:max-w-xl">
        <DialogHeader><DialogTitle>Minutes of meeting · {meeting?.title}</DialogTitle></DialogHeader>
        <label className="space-y-1.5 text-xs font-semibold text-zinc-600"><span>Discussion points</span>
          <textarea data-testid="mom-discussion-input" rows={5} value={f.discussion} onChange={(e) => setF({ ...f, discussion: e.target.value })} className={ta} /></label>
        <label className="space-y-1.5 text-xs font-semibold text-zinc-600"><span>Decisions taken</span>
          <textarea data-testid="mom-decisions-input" rows={4} value={f.decisions} onChange={(e) => setF({ ...f, decisions: e.target.value })} className={ta} /></label>
        <p className="text-xs text-zinc-500">Add action items (POA) from the meeting card after publishing. Every attendee gets a notification to acknowledge.</p>
        <div className="flex justify-end"><Button data-testid="mom-publish-button" disabled={busy || !(f.discussion || f.decisions)} onClick={save}>Publish MOM</Button></div>
      </DialogContent>
    </Dialog>
  );
}
